<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Personal</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Professional</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3">Training</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="mb-5"><personal-form :save="save.personalForm" :editMode="true" @resetSave="resetSavePersonalInformation($event)"></personal-form></v-card>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn color="primary"
          round @click.native="continuePersonalInformation">Save &amp; Continue</v-btn>
        </v-layout>
      </v-stepper-content>
      <v-stepper-content step="2">
        <education-card></education-card>
        <work-card></work-card>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn @click.native="e1 = 1" outline round color="primary">Previous</v-btn>
          <v-btn color="primary"
          round
         @click.native="continueProfessionalInformation">Save &amp; Continue</v-btn>
        </v-layout>
      </v-stepper-content>
      <v-stepper-content step="3">
        <skill-card></skill-card>
        <domain-industry-form :save="save.domainIndustry" @resetSave="resetDomainIndustry($event)"></domain-industry-form>
        <div class="heading text-xs-center">
          One last thing! Please upload your resume <v-icon>sentiment_satisfied_alt</v-icon>
          <br />
          <document-upload-card documentType="resume"></document-upload-card>
        </div>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-btn @click.native="e1 = 2" outline round color="primary">Previous</v-btn>
          <v-btn color="primary" round @click.native="continueSkillInformation">Finish</v-btn>
        </v-layout>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
/* globals Store */
import auth from '@/utils/auth'
import PersonalForm from '@/components/forms/PersonalForm'
import DomainIndustryForm from '@/components/forms/DomainIndustryForm'
import EducationCard from '@/components/EducationCard'
import WorkCard from '@/components/WorkCard'
import SkillCard from '@/components/SkillCard'
import DocumentUploadCard from '@/components/DocumentUploadCard'
import {
  sendWarningNotice,
  closeNotice
} from '@/utils/store-util.js'
export default {
  name: 'Profile-Completion',
  components: {
    PersonalForm,
    EducationCard,
    WorkCard,
    SkillCard,
    DomainIndustryForm,
    DocumentUploadCard
  },
  data () {
    return {
      e1: 0,
      save: {
        personalForm: false,
        domainIndustry: false
      },
      industrySwitch: false
    }
  },
  mounted () {
    auth.onChange(true, auth.profileMode())
  },
  computed: {
    completion () {
      return Store.state.user.completion
    }
  },
  methods: {
    continuePersonalInformation () {
      this.save.personalForm = true
    },
    continueProfessionalInformation () {
      if (Store.state.profile.educationList.length === 0 && Store.state.profile.workExperienceList.length === 0) {
        sendWarningNotice(null, 'Add atleast one education and employment')
        closeNotice(null, 20000)
      } else if (Store.state.profile.workExperienceList.length === 0) {
        sendWarningNotice(null, 'Add atleast one employment')
        closeNotice(null, 20000)
      } else if (Store.state.profile.educationList.length === 0) {
        sendWarningNotice(null, 'Add atleast one education')
        closeNotice(null, 20000)
      } else {
        this.e1 = 3
      }
    },
    continueSkillInformation () {
      this.save.domainIndustry = true
      this.$router.push('/dashboard')
    },
    resetSavePersonalInformation (status) {
      if (status) {
        this.e1 = 2
      }
      this.save.personalForm = false
    },
    resetDomainIndustry (status) {
      if (status) {
        if (Store.state.profile.skillList.length === 0 && (Store.state.profile.profile.resumePrivateUrl === null || Store.state.profile.profile.resumePrivateUrl === '')) {
          sendWarningNotice(null, 'Add atleast one skill and resume')
          closeNotice(null, 20000)
        } else if (Store.state.profile.skillList.length === 0) {
          sendWarningNotice(null, 'Add atleast one skill')
          closeNotice(null, 20000)
        } else if (Store.state.profile.profile.resumePrivateUrl === null || Store.state.profile.profile.resumePrivateUrl === '') {
          sendWarningNotice(null, 'Add resume')
          closeNotice(null, 20000)
        } else {
          auth.onChange(true, auth.profileMode())
          this.$router.push('/dashboard')
        }
      }
      this.save.domainIndustry = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ProfileCompletion.vue